import { UPDATE_USER_PHOTO_URL, USER_PROFILE_PHOTO_FLAG } from '../actionTypes';

const getInitialState = () => ({
  profilePhotoURL: null,
  profilePhotoFlag: false,
});

export default function (state = getInitialState(), action) {
  switch (action.type) {
    case UPDATE_USER_PHOTO_URL: {
      const { profilePhotoURL } = action.payload;
      return {
        ...state,
        profilePhotoURL,
      };
    }

    // TODO: Use this flag to control dropdown options in Dashboard.js
    case USER_PROFILE_PHOTO_FLAG: {
      const { profilePhotoFlag } = action.payload;
      return {
        ...state,
        profilePhotoFlag,
      };
    }

    default:
      return state;
  }
}
